















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

interface OptionType {
  label: string
  value: string
}

@Component
export default class PopupSelect extends Vue {
  isExpanded = false
  selectedValue = ''

  @Prop({ type: String, default: '' })
  title!: string

  @Prop({ type: Array, default: () => [] })
  options!: OptionType[]

  @Prop({ type: String, default: '' })
  value!: string

  get selectedLabel() {
    const item = this.options.find(opt => opt.value === this.selectedValue)
    return item ? item.label : ''
  }

  @Watch('value')
  watchValue(newVal: string) {
    this.selectedValue = newVal
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded
    if (this.isExpanded) {
      document.addEventListener('click', this.handleDocumentClick)
    } else {
      document.removeEventListener('click', this.handleDocumentClick)
    }
  }

  handleDocumentClick(event: MouseEvent) {
    const popupSelect = this.$refs.popupSelectRef as HTMLElement
    if (popupSelect && !popupSelect.contains(event.target as Node)) {
      this.isExpanded = false
      document.removeEventListener('click', this.handleDocumentClick)
    }
  }

  handleOptionClick(value: string) {
    this.selectedValue = value
    this.$emit('input', this.selectedValue)
    this.isExpanded = false
    document.removeEventListener('click', this.handleDocumentClick)
  }

  mounted() {
    this.selectedValue = this.value
  }

  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick)
  }
}
